<div pmdModal
    modalTrap
    #RejectInvoice="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="BulkRejectLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header pb-3 border-b-1 align-items-center"
                style="z-index: 9999;">
                <h4 class="modal-title">Help us know your reason for rejection</h4>
                <button aria-label="Close"
                    (click)="hide()"
                    [disabled]="submitting"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body">
                <pmd-form-group class="mb-3">
                    <ng-select id="bulk-reject-reason"
                        class="pmd-select pmd-select-outline"
                        appearance="outline"
                        [clearable]="selectedReasonId ? true : false"
                        [searchable]="false"
                        [disabled]="submitting"
                        placeholder="Select reason *"
                        [(ngModel)]="selectedReasonId">
                        <ng-option *ngFor="let reason of rejectionReasons"
                            [value]="reason.id">{{ reason.name }}</ng-option>
                    </ng-select>
                </pmd-form-group>
                <div [ngClass]="otherReason ? 'pmd-textfield-floating-label-completed mb-3' : 'mb-3'">
                    <label for="bulk-other-reason"
                        class="control-label mb-1">
                        Tell us more
                    </label>
                    <textarea id="bulk-other-reason"
                        type="text"
                        class="form-control"
                        [(ngModel)]="otherReason"
                        [disabled]="submitting"
                        aria-label="type your message">
                    </textarea>
                </div>
            </div>
            <div class="modal-footer justify-content-start mt-2">
                <button aria-label="Submit bulk rejection"
                    (click)="submit()"
                    type="button"
                    pmd-btn
                    pmdRipple
                    color="secondary"
                    [disabled]="!selectedReasonId || submitting"
                    [attr.aria-disabled]="!selectedReasonId || submitting">
                    Submit
                </button>
                <button aria-label="Close"
                    (click)="hide()"
                    pmdRipple
                    type="button"
                    pmd-btn
                    color="light"
                    [disabled]="submitting">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>
